import * as Util from "../common/util";
import * as Data from "../interfaces/data";
import * as Translations from "../interfaces/translations";

export interface IUserProfileMaster {
    TimeZoneID: number;
    LanguageID: number;
    TimeZones: Array<Data.ICodeModel<number>>;
    Languages: Translations.ILanguage[];
}
export function GetUserProfileMaster(): JQueryDeferred<Data.IResponse<IUserProfileMaster>> {
    return Util.callWebService(
        "/api/UserProfile/GetUserProfileMaster",
        "GET");
}
export function SaveUserProfileMaster(userProfileMaster: IUserProfileMaster): JQueryDeferred<Data.IResponse<boolean>> {
    return Util.callWebService(
        "/api/UserProfile/SaveUserProfileMaster", "POST", userProfileMaster);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/data/userProfileData.ts